import React, {cloneElement, isValidElement} from "react";

export function CardMetadata(props) {
  return (
    <div className={`card-metadata ${props.className || ""}`}>
      {
        React.Children.map(
          props.children, c => (isValidElement(c)) ? cloneElement(c, {...props, ...c.props}) : c
        )
      }
    </div>
  );
}
